import { createExtensionPoint } from '@interhyp/platform-plugin';
/**
 * This file contains several plugin definitions for each dashboard one
 */
/**
 * @deprecated
 */
export const brokerDashboardPlugin = createExtensionPoint(Symbol('broker-dashboard'), true);
export const customerDashboardPlugin = createExtensionPoint(Symbol('customer-dashboard'), true);
export const professionalDashboardPlugin = createExtensionPoint(Symbol('professional-dashboard'), true);
